import { render } from "./MfgAppPermission.vue?vue&type=template&id=b68a6a44"
import script from "./MfgAppPermission.vue?vue&type=script&lang=js"
export * from "./MfgAppPermission.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__